/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LobbyMediaItemResponse } from './LobbyMediaItemResponse';
import {
    LobbyMediaItemResponseFromJSON,
    LobbyMediaItemResponseFromJSONTyped,
    LobbyMediaItemResponseToJSON,
    LobbyMediaItemResponseToJSONTyped,
} from './LobbyMediaItemResponse';
import type { InstructionStepResponse } from './InstructionStepResponse';
import {
    InstructionStepResponseFromJSON,
    InstructionStepResponseFromJSONTyped,
    InstructionStepResponseToJSON,
    InstructionStepResponseToJSONTyped,
} from './InstructionStepResponse';

/**
 * 
 * @export
 * @interface LobbyInstructionsTemplateResponse
 */
export interface LobbyInstructionsTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    id?: string;
    /**
     * Template name (e.g., "Rocket League Private Match")
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    gameId?: string;
    /**
     * Denormalized game name for display
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    gameName?: string;
    /**
     * 
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    lobbyModel?: LobbyInstructionsTemplateResponseLobbyModelEnum;
    /**
     * Format for the auto-generated lobby name (e.g., "DEVOUR-{challengeId}")
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    lobbyNameFormat?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyInstructionsTemplateResponse
     */
    requiresPassword?: boolean;
    /**
     * Format for the auto-generated lobby password
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    passwordFormat?: string;
    /**
     * 
     * @type {Array<InstructionStepResponse>}
     * @memberof LobbyInstructionsTemplateResponse
     */
    createSteps?: Array<InstructionStepResponse>;
    /**
     * 
     * @type {Array<InstructionStepResponse>}
     * @memberof LobbyInstructionsTemplateResponse
     */
    joinSteps?: Array<InstructionStepResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LobbyInstructionsTemplateResponse
     */
    notes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LobbyInstructionsTemplateResponse
     */
    videoTutorialUrl?: string;
    /**
     * 
     * @type {Array<LobbyMediaItemResponse>}
     * @memberof LobbyInstructionsTemplateResponse
     */
    createMedia?: Array<LobbyMediaItemResponse>;
    /**
     * 
     * @type {Array<LobbyMediaItemResponse>}
     * @memberof LobbyInstructionsTemplateResponse
     */
    joinMedia?: Array<LobbyMediaItemResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LobbyInstructionsTemplateResponse
     */
    supportedFormats?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyInstructionsTemplateResponse
     */
    supportsSpectators?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LobbyInstructionsTemplateResponse
     */
    maxSpectators?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LobbyInstructionsTemplateResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LobbyInstructionsTemplateResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof LobbyInstructionsTemplateResponse
     */
    updatedAt?: number;
}


/**
 * @export
 */
export const LobbyInstructionsTemplateResponseLobbyModelEnum = {
    NAME_PASSWORD: 'NAME_PASSWORD',
    INVITE_ONLY: 'INVITE_ONLY',
    LOBBY_CODE: 'LOBBY_CODE',
    MATCHMAKING_KEY: 'MATCHMAKING_KEY',
    SERVER_BROWSER: 'SERVER_BROWSER'
} as const;
export type LobbyInstructionsTemplateResponseLobbyModelEnum = typeof LobbyInstructionsTemplateResponseLobbyModelEnum[keyof typeof LobbyInstructionsTemplateResponseLobbyModelEnum];


/**
 * Check if a given object implements the LobbyInstructionsTemplateResponse interface.
 */
export function instanceOfLobbyInstructionsTemplateResponse(value: object): value is LobbyInstructionsTemplateResponse {
    return true;
}

export function LobbyInstructionsTemplateResponseFromJSON(json: any): LobbyInstructionsTemplateResponse {
    return LobbyInstructionsTemplateResponseFromJSONTyped(json, false);
}

export function LobbyInstructionsTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LobbyInstructionsTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'lobbyModel': json['lobbyModel'] == null ? undefined : json['lobbyModel'],
        'lobbyNameFormat': json['lobbyNameFormat'] == null ? undefined : json['lobbyNameFormat'],
        'requiresPassword': json['requiresPassword'] == null ? undefined : json['requiresPassword'],
        'passwordFormat': json['passwordFormat'] == null ? undefined : json['passwordFormat'],
        'createSteps': json['createSteps'] == null ? undefined : ((json['createSteps'] as Array<any>).map(InstructionStepResponseFromJSON)),
        'joinSteps': json['joinSteps'] == null ? undefined : ((json['joinSteps'] as Array<any>).map(InstructionStepResponseFromJSON)),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'videoTutorialUrl': json['videoTutorialUrl'] == null ? undefined : json['videoTutorialUrl'],
        'createMedia': json['createMedia'] == null ? undefined : ((json['createMedia'] as Array<any>).map(LobbyMediaItemResponseFromJSON)),
        'joinMedia': json['joinMedia'] == null ? undefined : ((json['joinMedia'] as Array<any>).map(LobbyMediaItemResponseFromJSON)),
        'supportedFormats': json['supportedFormats'] == null ? undefined : json['supportedFormats'],
        'supportsSpectators': json['supportsSpectators'] == null ? undefined : json['supportsSpectators'],
        'maxSpectators': json['maxSpectators'] == null ? undefined : json['maxSpectators'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function LobbyInstructionsTemplateResponseToJSON(json: any): LobbyInstructionsTemplateResponse {
    return LobbyInstructionsTemplateResponseToJSONTyped(json, false);
}

export function LobbyInstructionsTemplateResponseToJSONTyped(value?: LobbyInstructionsTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'gameId': value['gameId'],
        'gameName': value['gameName'],
        'lobbyModel': value['lobbyModel'],
        'lobbyNameFormat': value['lobbyNameFormat'],
        'requiresPassword': value['requiresPassword'],
        'passwordFormat': value['passwordFormat'],
        'createSteps': value['createSteps'] == null ? undefined : ((value['createSteps'] as Array<any>).map(InstructionStepResponseToJSON)),
        'joinSteps': value['joinSteps'] == null ? undefined : ((value['joinSteps'] as Array<any>).map(InstructionStepResponseToJSON)),
        'notes': value['notes'],
        'videoTutorialUrl': value['videoTutorialUrl'],
        'createMedia': value['createMedia'] == null ? undefined : ((value['createMedia'] as Array<any>).map(LobbyMediaItemResponseToJSON)),
        'joinMedia': value['joinMedia'] == null ? undefined : ((value['joinMedia'] as Array<any>).map(LobbyMediaItemResponseToJSON)),
        'supportedFormats': value['supportedFormats'],
        'supportsSpectators': value['supportsSpectators'],
        'maxSpectators': value['maxSpectators'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

